import {
  PRICE_COMPONENT_LABEL,
  PRICE_COMPONENT_PRODUCT_NAME,
  PriceComponentType,
} from '../../Enums/price-component-type.enum';
import { PlanComponentResponse } from '../../Interfaces/api/backoffice/plan.interface';

export class PlanComponent {
  component_type = '';
  is_permitted = false;
  price_count = 0;
  offer_types: string[] = [];

  constructor(data: Partial<PlanComponentResponse> = {}) {
    Object.assign(this, data);
  }

  get componentLabelKey(): string {
    return PRICE_COMPONENT_LABEL[this.component_type as PriceComponentType] ?? this.component_type;
  }

  get sharedProductNameKey(): string {
    return (
      PRICE_COMPONENT_PRODUCT_NAME[this.component_type as PriceComponentType] ?? this.component_type
    );
  }

  get isAgent(): boolean {
    return this.component_type === PriceComponentType.AGENT;
  }

  get isAbsent(): boolean {
    return this.price_count === 0;
  }
}
